<template>
  <div>
    <template v-for="(item, index) in items">
      <v-layout row wrap align-center class="list-item py-2 px-3" @click="setTruncateText(index)" :key="`ns-itetm-${index}`">
        <v-flex xs2>
            {{ item.local_schedule_date | transform }}
        </v-flex>
        <v-flex xs10>
          <v-layout wrap row>
            <v-flex xs6>
              <v-icon class="small-icon mr-1">{{ item.channel_id | getChannelIcon }}</v-icon>
              <span class="text-capitalize">{{ item.channel.channel }}</span>
            </v-flex>
            <v-flex xs6>
              {{ item.status.status }}
            </v-flex>
          </v-layout>
          <v-layout wrap row>
            <v-flex xs6>
              {{ item.type_id | getType }}
            </v-flex>
            <v-flex xs6>
              Marca: {{ item.ns_informative == 0 ? 'Cobranza' : 'Informativo' }}
            </v-flex>
          </v-layout>
          <v-layout wrap row>
            <v-flex xs6  v-if="item.user">
              Operador: {{ item.user.first_name }} {{ item.user.last_name }}
            </v-flex>
            <v-flex xs6>
              Contacto: {{ item.to }}
            </v-flex>
          </v-layout>
          <v-layout wrap row>
            <v-flex xs12 :class="{
              'text-truncate': truncateText !== index,
            }">
              <span v-html="getText(item)"></span>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </template>
    <v-list three-line class="pa-0">
      <v-list-tile v-if="!items.length && !loading">
        <v-list-tile-content>
          <v-list-tile-title>
            <info :min-height="'50px;'">Sin gestiones</info>
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <template v-if="loading">
        <skeleton-box :delay="1">
          <v-list-tile  v-for="(item, index) in 10" :key="`ns-skeleton-${index}`">
            <v-list-tile-action>
              <skeleton-line size="lg">
              </skeleton-line>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                <v-layout row wrap class="pl-3">
                  <v-flex xs4>
                    <skeleton-line size="md">
                    </skeleton-line>
                  </v-flex>
                  <v-flex xs4>
                    <skeleton-line size="md">
                    </skeleton-line>
                  </v-flex>
                </v-layout>
              </v-list-tile-title>
              <v-list-tile-title>
                <v-layout row wrap class="pl-3">
                  <v-flex xs8>
                    <skeleton-line size="md">
                    </skeleton-line>
                  </v-flex>
                </v-layout>
              </v-list-tile-title>
              <v-list-tile-sub-title class="item-subtitle pl-3">
                <skeleton-line size="md">
                </skeleton-line>
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </skeleton-box>
      </template>
    </v-list>
  </div>
</template>

<script>
import moment from 'moment';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import SkeletonLine from '@/components/global/skeletons/Line';
import SkeletonBox from '@/components/global/skeletons/SkeletonBox';
import Info from '@/components/global/Info';

export default {
  components: {
    Info,
    SkeletonBox,
    SkeletonLine,
    VuePerfectScrollbar,
  },
  props: {
    customer: {
      type: Object,
      default: () => ({}),
    },
    items: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      truncateText: null,
    };
  },
  filters: {
    transform(value) {
      return moment(value, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY');
    },
    getType(value) {
      let text = '';
      switch (value) {
        case 1:
          text = 'Carga diaria';
          break;
        case 2:
          text = 'Campañas';
          break;
        case 3:
          text = 'Prueba';
          break;
        case 4:
          text = 'Chat center';
          break;
        case 5:
          text = 'Chat center';
          break;
        case 7:
          text = 'Inbound';
          break;
        case 8:
          text = 'Inbound';
          break;
      }
      return text;
    },
    getChannelIcon(value) {
      let icon = '';
      switch (value) {
        case 1:
          icon = 'fas fa-envelope';
          break;
        case 2:
          icon = 'fas fa-comments';
          break;
        case 3:
          icon = 'fas fa-phone';
          break;
        case 4:
          icon = 'fas fa-robot';
          break;
        case 5:
          icon = 'fas fa-user';
          break;
        case 6:
          icon = 'fas fa-users';
          break;
        case 7:
          icon = 'fab fa-whatsapp';
          break;
        default:
          icon = 'fas fa-user';
          break;
      }
      return icon;
    },
  },
  methods: {
    getText(value) {
      if (value.channel_id === 4) {
        return '';
      }
      if ([1, 2].includes(value.channel_id)) {
        if (value.channel_id === 1) {
          const html = value.text;
          const div = document.createElement('div');
          div.innerHTML = html;
          const text = div.textContent || div.innerText || '';
          return text;
        } else {
          return value.text;
        }
      }
      return value.descrip;
    },
    setTruncateText(index) {
      if (this.truncateText === index) {
        this.truncateText = null;
      } else {
        this.truncateText = index;
      }
    }
  },
};
</script>

<style scope lang="css">
  .ns-scrollbar {
    height: calc(100vh - 80px);
  }
  .small-icon.icon {
    font-size: 14px !important;
  }
  .item-subtitle {
    max-width: 400px;
  }
  .list-item {
    cursor: pointer;
  }
  .list-item:not(:first-child) {
    border-top: 1px solid #ccc;
  }
  .text-truncate {
    width: 250px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>


// WEBPACK FOOTER //
// src/components/customer/CustomerContactedNotifications.vue